import { render, staticRenderFns } from "./TicketManage.vue?vue&type=template&id=3d13f204&scoped=true&"
import script from "./TicketManage.vue?vue&type=script&lang=js&"
export * from "./TicketManage.vue?vue&type=script&lang=js&"
import style0 from "./TicketManage.vue?vue&type=style&index=0&id=3d13f204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d13f204",
  null
  
)

export default component.exports